// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5797":"4b751ee9","6272":"4b751ee9","7445":"4233ddbc"}[chunkId] + ".chunk.css";
};